import { render, staticRenderFns } from "./SyncToTNArticle.vue?vue&type=template&id=093761c7&"
import script from "./SyncToTNArticle.vue?vue&type=script&lang=js&"
export * from "./SyncToTNArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports